import { Pipe, PipeTransform } from '@angular/core';
import { AssetDataDto, PartialAssetDataDto } from '@nusign/picflow-backend-types';

@Pipe({
  name: 'videoResolutionType',
  standalone: true,
  pure: true,
})
export class VideoResolutionTypePipe implements PipeTransform {
  transform(data: AssetDataDto | PartialAssetDataDto): string {
    if (!data) return 'sd'; // default to sd if no data
    if (!('width' in data)) return;
    const res = Math.min(data.width, data.height);
    if (res <= 720) return 'sd';
    if (res < 1440) return 'hd';
    if (res < 2160) return '2k';
    return '4k';
  }
}
